export default __webpack_public_path__ + "static/media/chongdongyeon_b.8796d66f.png";